export default {
  dispenseBaseLookup: [],
  UOMLookup: [],
  dispenseTypeLookup: [],
};
